<template>
  <div
    class="form-field-item headerStyles"
    style="display: flex; align-items: center; gap: 12px; padding: 6px 10px"
  >
    <span style="font-size: 13px; color: #606266">
      {{ item.label || item.type }}
      <span v-if="item.key" style="color: #909399">({{ item.key }})</span>
    </span>
    <el-checkbox v-model="item.required" @change="$emit('required-change', $event)">
      Required
    </el-checkbox>
  </div>
</template>

<script>
export default {
  name: "SelectedFieldRequiredBar",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
